import React, { useState } from "react";
import "./leaveorgin.css";

export default function LeavePreference() {
  const [isChecked1, setIsChecked1] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);
  const [isChecked3, setIsChecked3] = useState(false);

  const handleCheckboxChange1 = () => {
    setIsChecked1(!isChecked1);
  };

  const handleCheckboxChange2 = () => {
    setIsChecked2(!isChecked2);
  };

  const handleCheckboxChange3 = () => {
    setIsChecked3(!isChecked3);
  };

  return (
    <div className="p-2 ">
      <div>
        <span className="breachCrumb" style={{ color: "#141414" }}>
          Setting / Perference
        </span>
      </div>
      <h5>LEAVE PREERENCE</h5>
      <div className="checkbox-group  border rounded col-md-6 p-4 mt-3">
        <label className="checkbox pb-4">
          <input
            type="checkbox"
            checked={isChecked1}
            onChange={handleCheckboxChange1}
          />
          Lock Submitted Records In Leave
        </label>
        <label className="checkbox pb-4">
          <input
            type="checkbox"
            checked={isChecked2}
            onChange={handleCheckboxChange2}
          />
          Lock In-Approval/Approved Records In Leave
        </label>
        <label className="checkbox pb-4">
          <input
            type="checkbox"
            checked={isChecked3}
            onChange={handleCheckboxChange3}
          />
          Description Required
        </label>
        <label className="checkbox pb-4">
          <input
            type="checkbox"
            checked={isChecked3}
            onChange={handleCheckboxChange3}
          />
          Show In Hours Form
        </label>
        <label className="checkbox pb-4">
          <input
            type="checkbox"
            checked={isChecked3}
            onChange={handleCheckboxChange3}
          />
          Auto Calculate Available Balance in Leave Status
        </label>
        <div className="update-button d-flex justify-content-end">
          <button className="button-outline mt-3">Update</button>
        </div>
      </div>
    </div>
  );
}
